// extracted by mini-css-extract-plugin
export default {"tool_card":"ToolCard_tool_card__QU5O+","bottom":"ToolCard_bottom__imktz"};